module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "locations"
    }
  }, [_c('tbody', [_vm._m(0), _vm._v(" "), _vm._l((_vm.inputs), function(input) {
    return _c('lookup-result', {
      key: input,
      attrs: {
        "uid": input
      }
    })
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Location")]), _vm._v(" "), _c('td', [_vm._v("  Latitude  ")]), _vm._v(" "), _c('td', [_vm._v("Longitude")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25f5a482"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Sidebar.vue
// module id = 814
// module chunks = 0